let closeNav = (e) => {
    let navbarBtn = document.querySelector("button.navbar-toggler");
    navbarBtn.click();
}
module.exports = { closeNav }